"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter of {@link PromotionArea PromotionArea}.
 * @author OPt
 */


var PromotionAreaConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionAreaConverter, _DataObjectConverter_);

  function PromotionAreaConverter() {
    _classCallCheck(this, PromotionAreaConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaConverter).apply(this, arguments));
  }

  return PromotionAreaConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionAreaConverter = PromotionAreaConverter;